// Copy the NESAB code. Success says Copied; failure selects the code so it can be copied by hand. Both are announced.
// Safe to load more than once on a page: each code block is wired once.
(function(){
  function wire(c){
    if(c.dataset.nzcOn) return; c.dataset.nzcOn='1';
    var b=c.querySelector('button'), s=c.querySelector('.nzc__s'), t; if(!b) return;
    b.addEventListener('click',function(){
      var ok=function(){c.classList.remove('is-fail');c.classList.add('is-copied');s.textContent='Code '+c.dataset.code+' copied';clearTimeout(t);t=setTimeout(function(){c.classList.remove('is-copied')},1800)};
      var fail=function(){var r=document.createRange(),g=getSelection();r.selectNodeContents(c.querySelector('code'));g.removeAllRanges();g.addRange(r);c.classList.add('is-fail');s.textContent='Code selected. Copy it by hand.'};
      if(navigator.clipboard&&window.isSecureContext){navigator.clipboard.writeText(c.dataset.code).then(ok,fail)}else{fail()}
    });
  }
  function all(){document.querySelectorAll('.nzc').forEach(wire)}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',all)}else{all()}
  document.addEventListener('shopify:section:load',all);
})();
